export enum ORDER_ITEM_TYPE {
  SUBSCRIPTION = 'subscription',
  NEXT_ORDER = 'next-order',
  TO_BE_APPLIED_AFTER_NEXT_ORDER = 'to-be-applied-after-next-order',
  PAST_ORDER = 'past-order'
}
